var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asd20-tag-group",class:_vm.classes},[_vm._l((_vm.tags),function(tag,index){return _c('asd20-tag',{key:index,attrs:{"label":tag}})}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }